module.exports = __webpack_public_path__ + "media/icecrackfour.1f720536.mp3";